import React from "react";
import styles from "./MainField.module.css";
import { FiEdit, FiEdit2 } from "react-icons/fi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { IoMdTrash } from "react-icons/io";

export default function MainField({
  title = "Section Title",
  showCheckbox = true,
  checkboxLabel = "Insert page break after the field",
  checked = false,
  onCheck = () => {},
  onEdit = () => {},
  onDelete = () => {},
  onToggleCollapse = () => {},
  collapsed = false,
}) {
  return (
    <div className={styles.mainFieldContainer}>
      <div className={styles.lightBox}>
        <div className={styles.leftContent}>
          <h4 className={styles.title}>{title}</h4>
          {showCheckbox && (
            <label className={styles.customCheckboxLabel}>
              <input
                type="checkbox"
                checked={checked}
                onChange={onCheck}
                className={styles.hiddenCheckbox}
              />
              <span className={styles.customBox}></span>
              {checkboxLabel}
            </label>
          )}
        </div>
        <div className={styles.iconGroup}>
          <FiEdit onClick={onEdit} />
          <IoMdTrash className={styles.deleteIcon} onClick={onDelete} />
        </div>
      </div>

      <div className={styles.rightBox} onClick={onToggleCollapse}>
        <div className={`${styles.bars} ${collapsed ? styles.rotate : ""}`}>
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
}
